import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreKeysEnum } from '../../../store/store-keys'
import { ActionProgressDialogReducer } from './state/action-progress-dialog.reducer'
import { ActionProgressDialogEffects } from './state/action-progress-dialog.effects'
import { ActionProgressDialogComponent } from './action-progress-dialog.component'

@NgModule({
    declarations: [ActionProgressDialogComponent],
    exports: [ActionProgressDialogComponent],
    imports: [
        CommonModule,
        StoreModule.forFeature(StoreKeysEnum.ActionProgressDialogComponent, ActionProgressDialogReducer),
        EffectsModule.forFeature([ActionProgressDialogEffects]),
    ],
})
export class ActionProgressDialogModule {}
